import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  IconButton,
} from "@mui/material";
import { X } from "lucide-react";

const MOTIVOS_CANCELAMENTO = {
  "Cliente - Desistência": [
    { value: "CLIENTE_DESISTIU", label: "Cliente desistiu da consulta" },
    { value: "CLIENTE_MUDOU_CLINICA", label: "Cliente mudou de clínica" },
    { value: "CLIENTE_MUDOU_CIDADE", label: "Cliente mudou de cidade/país" },
    {
      value: "CLIENTE_SEM_DISPONIBILIDADE_FINANCEIRA",
      label: "Sem disponibilidade financeira",
    },
  ],
  "Cliente - Indisponibilidade": [
    { value: "CLIENTE_PROBLEMA_SAUDE", label: "Problema de saúde do cliente" },
    { value: "CLIENTE_EMERGENCIA_FAMILIAR", label: "Emergência familiar" },
    { value: "CLIENTE_EM_VIAGEM", label: "Cliente em viagem" },
    { value: "CLIENTE_CONFLITO_HORARIO", label: "Conflito de horário" },
  ],
  "Cliente - Sem Contacto": [
    { value: "CLIENTE_NAO_ATENDEU", label: "Cliente não atendeu chamadas" },
    {
      value: "CLIENTE_NAO_RESPONDEU",
      label: "Cliente não respondeu mensagens",
    },
    { value: "CONTACTO_INVALIDO", label: "Contacto inexistente/inválido" },
  ],
  "Clínica - Operacional": [
    { value: "MEDICO_INDISPONIVEL", label: "Médico indisponível" },
    { value: "CLINICA_ENCERRADA", label: "Clínica encerrada temporariamente" },
    { value: "ERRO_AGENDAMENTO", label: "Erro no agendamento" },
    { value: "CLIENTE_DUPLICADO", label: "Cliente duplicado" },
  ],
  "Clínica - Clínico": [
    { value: "CLIENTE_NAO_NECESSITA", label: "Cliente não necessita limpeza" },
    {
      value: "CLIENTE_EM_TRATAMENTO_ORTODONTICO",
      label: "Cliente em tratamento ortodôntico",
    },
    { value: "CONDICAO_CLINICA_ALTERADA", label: "Condição clínica alterada" },
  ],
  Administrativo: [
    { value: "AGENDAMENTO_ERRO_SISTEMA", label: "Erro de sistema" },
    { value: "MIGRACAO_DADOS", label: "Migração de dados" },
    { value: "CLIENTE_FALECIDO", label: "Cliente falecido" },
  ],
  Conversão: [
    { value: "CONVERTIDO_TRATAMENTO", label: "Convertido em tratamento" },
    { value: "CLIENTE_JA_COMPARECEU", label: "Cliente já compareceu" },
    { value: "AGENDAMENTO_ANTECIPADO", label: "Agendamento antecipado" },
  ],
  Outros: [{ value: "OUTRO", label: "Outro motivo" }],
};

function ModalCancelarAgendamento({ open, onClose, agendamento, onConfirm }) {
  const [motivo, setMotivo] = useState("");
  const [observacoes, setObservacoes] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!motivo) {
      alert("Por favor, selecione um motivo para o cancelamento.");
      return;
    }

    setLoading(true);
    try {
      await onConfirm(motivo, observacoes);
      handleClose();
    } catch (err) {
      console.error("Erro ao cancelar:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setMotivo("");
    setObservacoes("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Cancelar Agendamento</span>
          <IconButton onClick={handleClose} size="small">
            <X size={20} />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" style={{ marginBottom: "16px" }}>
          Tem certeza que deseja cancelar o agendamento de{" "}
          <strong>{agendamento?.cliente?.nome}</strong>?
        </Alert>

        <FormControl fullWidth margin="normal" required>
          <InputLabel>Motivo do Cancelamento</InputLabel>
          <Select
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            label="Motivo do Cancelamento"
          >
            {Object.entries(MOTIVOS_CANCELAMENTO).map(
              ([categoria, motivos]) => [
                <MenuItem
                  key={categoria}
                  disabled
                  style={{ fontWeight: "bold", opacity: 0.7 }}
                >
                  {categoria}
                </MenuItem>,
                ...motivos.map((m) => (
                  <MenuItem
                    key={m.value}
                    value={m.value}
                    style={{ paddingLeft: "24px" }}
                  >
                    {m.label}
                  </MenuItem>
                )),
              ]
            )}
          </Select>
        </FormControl>

        <TextField
          label="Observações (opcional)"
          multiline
          rows={4}
          fullWidth
          margin="normal"
          value={observacoes}
          onChange={(e) => setObservacoes(e.target.value)}
          placeholder="Adicione detalhes adicionais sobre o cancelamento..."
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Voltar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="error"
          disabled={loading || !motivo}
        >
          {loading ? "Cancelando..." : "Confirmar Cancelamento"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModalCancelarAgendamento;
